<!-- <li class="panel"> -->
<div class="controparte">
	<p class="col-sm-2">
		<button (click)="emitEntity(bene)" class="btn btn-primary associa"
			type="submit">Allega</button>
	</p>
	<div>
		<h4 class="titolo col-sm-2">{{bene.tipoCatasto.label}}</h4>
		<p class="col-sm-3">
			Valore bene: <strong>{{ bene.valore | euro}}</strong>
		</p>
		<p class="col-sm-2">
			<strong *ngIf="bene.istanzaVendita.vendita">VENDUTO</strong> <strong
				*ngIf="!bene.istanzaVendita.vendita">NON VENDUTO</strong>
		</p>
		<p class="col-sm-2 status">
			<strong *ngIf="bene.istanzaAssegnazione.assegnato">ASSEGNATO</strong>
			<strong *ngIf="!bene.istanzaAssegnazione.assegnato">NON
				ASSEGNATO</strong>
		</p>
	</div>
</div>
<!-- </li> -->
